import { makeStyles } from '@material-ui/core';
import { DialogTitle, IconButton, Typography } from "@material-ui/core";
import { Close } from "@material-ui/icons";

const useStyles = makeStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
}))

function DialogCloseableTitle(props) {
  const classes = useStyles();
  const { onClose, hideClose, ...other } = props;
  return (
    <DialogTitle className={classes.root} disableTypography {...other}>
      <Typography>{props.children}</Typography>
      {onClose && !hideClose ?
        <IconButton size="small" className={classes.closeButton} onClick={onClose}>
          <Close />
        </IconButton>
        :
        null
      }
    </DialogTitle>
  )
}

DialogCloseableTitle.defaultProps = {
  hideClose: false
}

export default DialogCloseableTitle